/* global L */
import { createPathComponent } from "@react-leaflet/core";
import "leaflet.markercluster";

// This component is borrowed from the `react-leaflet-markercluster` package which has
// been archived/deprecated, so we handle it here to allow us to upgrade the code
// (which is quite simple) if the `react-leaflet` API changes in the future.
//
const MarkerClusterGroup = createPathComponent(({ children: _c, ...props }, ctx) => {
  const clusterProps = {};
  const clusterEvents = {};

  // Splitting props and events to different objects
  Object.entries(props).forEach(([propName, prop]) =>
    propName.startsWith("on")
      ? (clusterEvents[propName] = prop)
      : (clusterProps[propName] = prop)
  );

  // Creating markerClusterGroup Leaflet element
  const markerClusterGroup = new L.markerClusterGroup(clusterProps);

  // Initializing event listeners
  Object.entries(clusterEvents).forEach(([eventAsProp, callback]) => {
    const clusterEvent = `cluster${eventAsProp.substring(2).toLowerCase()}`;
    markerClusterGroup.on(clusterEvent, callback);
  });

  return {
    instance: markerClusterGroup,
    context: { ...ctx, layerContainer: markerClusterGroup }
  };
});

export default MarkerClusterGroup;
